import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import { forwardRef } from 'react';
import classNames from 'classnames';
const ActionBarItemIcon = forwardRef((props, ref) => {
    const { className, children } = props, remainingProps = __rest(props, ["className", "children"]);
    const classes = classNames('ActionBarItemIcon', className);
    return (_jsx("div", Object.assign({}, remainingProps, { className: classes, ref: ref }, { children: children })));
});
// The displayName is used in ActionBarItem for checking the component "isActionBarItemIcon"
ActionBarItemIcon.displayName = 'ActionBarItemIcon';
export default ActionBarItemIcon;
